module.exports = __webpack_public_path__ + "static/img/personal_info.6724d36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/default/personal_info.jpg
// module id = 133
// module chunks = 93